import { Route, Routes } from 'react-router-dom'
import NutritionCalculatorFormPage from '../nutritionCalculator/NutritionCalculatorFormPage'

export default function Body() {
  return (
    <div className="content-wrapper">
      <section className="content body">
        <div className="row">
          <Routes>
            <Route path="/" element={<NutritionCalculatorFormPage />} />
          </Routes>
        </div>
      </section>
    </div>
  )
}
